export default __webpack_public_path__ + "static/media/sketchdefaultcourt.6596a47e.jpg";